import React, { useEffect, useState } from 'react';
// import { redirect } from 'react-router-dom';
import { Button, Input, message } from 'antd';
import useInput from '../../../../hooks/useInput';
import { authApi } from '../../../../apis';

/**
 * 페스워드 찾기 페이지
 * @author
 * */
const FindPassword = (props) => {
  // const navigate = useNavigate();
  const email = useInput('');
  const [messageApi, contextHolder] = message.useMessage();

  const sendPassword = async () => {
    // window.location.replace(
    //   `/password/confirm?id=${String(email.value || '').trim()}`
    // );
    // return;

    const tmpEmail = String(email.value || '').trim();
    if (tmpEmail.length) {
      const response = await authApi.post('/admin/reset', {
        email: tmpEmail,
      });

      // console.log('---->', tmpEmail, '--->', response);
      if (response && response.data && response.data.message == 'OK') {
        window.location.replace(
          `/password/confirm?id=${String(email.value || '').trim()}`
        );
        return;
      }
    }
    messageApi.error('메일을 전송하는데 실패하였습니다.');
  };

  const styles = {
    input: { height: 34, width: 353, marginTop: 37, marginLeft: 16, border: 0 },
    button: {
      height: 34,
      width: 353,
      marginTop: 16,
      marginLeft: 16,
      background: '#7367F0',
    },
    link: {
      height: 34,
      width: 353,
      marginTop: 16,
      marginLeft: 16,
      // font
      fontWeight: 400,
      fontSize: '1.5rem',
      lineHeight: '2.2rem',
      color: '#7367F0',
    },
  };
  return (
    <div className="container">
      {contextHolder}
      <div className="topArea">
        <div className="topBox" style={{ marginTop: '1rem' }} />
        <div className="topBorderBox" style={{ marginLeft: '-5rem' }} />
      </div>
      <div style={{ height: '32rem' }} />
      <div className="bottomArea">
        <div className="bottomBorderBox" style={{ marginRight: '8rem' }}>
          <div className="bottomBox" />
        </div>
      </div>
      <div
        className="centerArea"
        style={{
          flexDirection: 'column',
          marginTop: '-65rem',
          marginLeft: '-8rem',
          backgroundImage: `url(${require('../../../../assets/images/bkg_pwd_find.png')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          paddingTop: '23rem',
          paddingLeft: '3.2rem',
        }}
      >
        <Input
          style={{ ...styles.input }}
          placeholder={'Admin@Balancefit.kr'}
          allowClear
          // {...email}
          onChange={email.onChange}
        />

        <Button
          type="primary"
          style={{
            ...styles.button,
          }}
          onClick={(e) => {
            // console.log('password');
            sendPassword();
          }}
        >{`새 비밀번호 설정 링크 보내기`}</Button>

        <Button
          type="link"
          style={{
            ...styles.link,
          }}
          onClick={(e) => {
            window.location.replace('/');
          }}
        >{`< 로그인 페이지로 돌아가기`}</Button>
      </div>
    </div>
  );
};

export default FindPassword;
